<template>
  <ul
    @mouseleave="visible = depth<1"
  >
    <li
      @mouseover="visible = true"
      v-if="node.id"
      :style="{'margin-left': `${depth * 20}px`}" 
      class="node"
    >
      <a
        href="#"
      >{{node.name}}</a>
    </li>
    <TreeBrowser
      @mouseover="visible = true"
      v-show="visible"
      v-for="(child, index) in node.children"
      :key="index"
      :node="child"
      :depth="depth+1"
     />
  </ul>
</template>

<script>
  const props = {
    node: Object,
    depth: {
      type: Number,
      default: 0,
    }
  }

  export default {
    name: 'TreeBrowser',
    props,
    data() {
      return {
        visible: this.depth<1
      }
    },
  }
</script>

<style scoped>
  .node {
    text-align: left;
  }
  ul {
    list-style: none;
  }
</style>